import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {
  aboutLink,
  contactLink,
  exploreLink,
  faqLink,
  internshipLink,
  internshipID,
  PrivacyPolicyLink,
  profileLink,
  TermsAndConditionsLink,
  userInternshipsLink,
} from "../common/routes";
import Xpverse from "../pages/xpverse/xpverse";
import NotFound from "../components/notFound/notFound";
import Homepage from "../pages/xpverse/homepage";
import AllInternshipsPage from "../pages/internships/allInternships";
import InternshipDetailsPage from "../pages/internships/internshipDetails";
import FaqPage from "../pages/faq/faqPage";
import AuthRouter from "../pages/auth/authRouter";
import ExplorePage from "../pages/explore/explorePage";
import ContactUsPage from "../pages/contact/contactUsPage";
import ProfilePage from "../pages/userProfile/profilePage";
import EnrolledIntershipsPage from "../pages/enrolledInternships/enrolled";
import AboutPage from "../pages/aboutUs/about";
import TermsAndConditionsPage from "../pages/termsAndPolicies/termsPage";
import PrivacyPolicyPage from "../pages/termsAndPolicies/policyPage";

function IndexRouter() {
  return (
    <Router>
      <Routes>
        {AuthRouter()}
        <Route path="/" element={<Xpverse />}>
          <Route index element={<Homepage />} />
          <Route path={internshipLink}>
            <Route index element={<AllInternshipsPage />} />
            <Route path={internshipID} element={<InternshipDetailsPage />} />
          </Route>
          <Route path={faqLink} element={<FaqPage />} />
          <Route path={exploreLink} element={<ExplorePage />} />
          <Route path={contactLink} element={<ContactUsPage />} />
          <Route path={profileLink} element={<ProfilePage />} />
          <Route
            path={userInternshipsLink}
            element={<EnrolledIntershipsPage />}
          />
          <Route path={aboutLink} element={<AboutPage />} />
          <Route
            path={TermsAndConditionsLink}
            element={<TermsAndConditionsPage />}
          />
          <Route path={PrivacyPolicyLink} element={<PrivacyPolicyPage />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default IndexRouter;
